/**
 * Registered-office NAP for the India marketing build only.
 * Returns null on flogpt.com, and the JSX below is dropped from that bundle.
 */
export default function IndiaFooterNotice() {
    if (import.meta.env.VITE_SITE_REGION !== "in") return null;
    return (
        <div className="mt-4 max-w-xl text-center sm:text-left">
            <p className="text-xs leading-5 text-slate-400">
                floGPT India is operated by VDigit Solutions Private Limited, a subsidiary of Pulse Real LLC.
            </p>
            <p className="mt-1 text-xs leading-5 text-slate-400">
                Unit No 4, Office A, 4th Floor, EK Tower, New Town, Kolkata, West Bengal 700161, India.{" "}
                <a href="tel:+919560303603" className="text-slate-300 hover:text-white transition-colors">
                    +91 9560303603
                </a>
            </p>
        </div>
    );
}
